<template>
  <div style="display: contents">
    <div class="toolbar-icon" :title="$t('title.basicFormatting')" @click="showStyles">
      <custom-icon :class-name="icons.Palette" />
    </div>
    <edit-toolbox v-if="showEditToolbox" />
  </div>
</template>
<script>
import { icons } from "../../../utils/icons";
import EditToolbox from "../body/edit-context-menu/EditToolbox.vue";
import CustomIcon from "../../commons/CustomIcon.vue";

export default {
  components: { EditToolbox, CustomIcon },
  data() {
    return {
      icons: icons,
    };
  },
  computed: {
    showEditToolbox() {
      return this.$store.state.preferences.showEditToolbox;
    },
  },
  methods: {
    showStyles(event) {
      this.$store.dispatch("preferences/toggleShowCutomStyles", false);
      this.$store.dispatch("preferences/toggleShowEditToolbox", true);
    },
    callFunc() {
      this.showStyles();
    },
  },
};
</script>
